import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AuditLogLoader } from '@confluence/audit-log/entry-points/AuditLogLoader.tsx';

const AUDIT_LOG_ANALYTICS_SOURCE = 'audit-log';

export const AuditLogRoute = () => <AuditLogLoader />;

AuditLogRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: AUDIT_LOG_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
